export enum GroupType {
	ORG = 'org',
	ACCOUNT = 'account',
	COURSE = 'course'
}
